const clubInfo= [
  {
    "clubee_name": "SC Frankfurt 1880",
    "details": {
      "club_name": "Sport Club Frankfurt 1880",
      "club_short": "SC Frankfurt 1880",
      "club_very_short": "SCF 1880",
      "city": "Frankfurt",
      "venue_name": "Sportanlage an der Feldgerichtstrasse",
      "venue_address": "Feldgerichtstraße 29, 60320 Frankfurt am Main"
    },
    "ui": {
      "color1": "#700e0e",
      "color2": "#848484",
      "color3": "#f3f3f3",
    }
  },
  {
    "clubee_name": "SC Frankfurt",
    "details": {
      "club_name": "Sport Club Frankfurt 1880",
      "club_short": "SC Frankfurt",
      "club_very_short": "SCF",
      "city": "Frankfurt",
      "venue_name": "Sportanlage an der Feldgerichtstrasse",
      "venue_address": "Feldgerichtstraße 29, 60320 Frankfurt am Main"
    },
  },
  {
    "clubee_name": "SC Neuenheim",
    "details": {
      "club_name": "Sportclub Neuenheim 1902",
      "club_short": "SC Neuenheim",
      "club_very_short": "SCN",
      "city": "Heidelberg",
      "venue_name": "Sportplatz SC Neuenheim",
      "venue_address": "Tiergartenstraße 7, 69120 Heidelberg"
    },
    "ui": {
      "color1": "#2c62ab",
      "color2": "#aca977",
      "color3": "#f9fbfb",
    }
  },
  {
    "clubee_name": "TSV Handschuhsheim",
    "details": {
      "club_name": "TSV Handschuhsheim",
      "club_short": "Handschuhsheim",
      "club_very_short": "TSV H",
      "city": "Heidelberg",
      "venue_name": "TSV Handschuhsheim Rugbyplatz",
      "venue_address": "Tiergartenstraße 7, 69120 Heidelberg"
    },
    "ui": {
      "color1": "#f8f3ca",
      "color2": "#717770",
      "color3": "#161514",
    }
  },
  {
    "clubee_name": "München RFC",
    "details": {
      "club_name": "München Rugby Football Club",
      "club_short": "München RFC",
      "club_very_short": "MRFC",
      "city": "München",
      "venue_name": "Sportanlage Großhadern",
      "venue_address": "Ludwig-Hunger-Straße 11, 81375 München"
    },
    "ui": {
      "color1": "#6fa4d9",
      "color2": "#717d70",
      "color3": "#fafbfa",
    }
  },
  {
    "clubee_name": "RG Heidelberg",
    "details": {
      "club_name": "Rudergesellschaft Heidelberg 1898",
      "club_short": "RG Heidelberg",
      "club_very_short": "RGH",
      "city": "Heidelberg",
      "venue_name": "Sportplatz RG Heidelberg",
      "venue_address": "Harbigweg 9, 69124 Heidelberg Kirchheim"
    },
    "ui": {
      "color1": "#2a665d",
      "color2": "#e87d01",
      "color3": "#f0f4f2",
    }
  },
  {
    "clubee_name": "Rugby Club Luxembourg",
    "details": {
      "club_name": "Rugby Club Luxembourg",
      "club_short": "RC Luxembourg",
      "club_very_short": "RCL",
      "city": "Luxembourg",
      "venue_name": "Terrains de Sport Boy Konen",
      "venue_address": "Rue des Sports 279, 1321 Luxembourg"
    },
    "ui": {
      "color1": "#2d93dc",
      "color2": "#ec445c",
      "color3": "#f2f6f9",
    }
  },
  {
    "clubee_name": "Heidelberger Ruderklub 1872",
    "details": {
      "club_name": "Heidelberger Ruderklub 1872",
      "club_short": "Heidelberger RK",
      "club_very_short": "HRK",
      "city": "Heidelberg",
      "venue_name": "Sportplatz Heidelberger RK",
      "venue_address": "Harbigweg 14, 69124 Heidelberg"
    },
    "ui": {
      "color1": "#fe0901",
      "color2": "#fabc0f",
      "color3": "#cfe1f2",
    }
  },
  {
    "clubee_name": "Heidelberger Ruderklub",
    "details": {
      "club_name": "Heidelberger Ruderklub",
      "club_short": "Heidelberger RK",
      "club_very_short": "HRK",
      "city": "Heidelberg",
      "venue_name": "Sportplatz Heidelberger RK",
      "venue_address": "Harbigweg 14, 69124 Heidelberg"
    },
  },
  {
    "clubee_name": "RSV Köln",
    "details": {
      "club_name": "Rugby Sport Verein Köln",
      "club_short": "RSV Köln",
      "club_very_short": "RSV",
      "city": "Köln",
      "venue_name": "Kölner Rugby Park",
      "venue_address": "Kölner Rugby Park, 50939 Köln"
    },
    "ui": {
      "color1": "#bb0748",
      "color2": "#dd81a4",
      "color3": "#fdfafb",
    }
  },
  {
    "clubee_name": "SC Germania List",
    "details": {
      "club_name": "SC Germania List",
      "club_short": "SC Germania List",
      "club_very_short": "SC GL",
      "city": "Hannover",
      "venue_name": "SC Germania List 1900 e.V.",
      "venue_address": "Schneckenburgerstraße 22G, 30177 Hannover"
    },
    "ui": {
      "color1": "#134887",
      "color2": "#e2b433",
      "color3": "#fdfcf7",
    }
  },
  {
    "clubee_name": "Hannover 78",
    "details": {
      "club_name": "Hannover 78",
      "club_short": "Hannover 78",
      "club_very_short": "H78",
      "city": "Hannover",
      "venue_name": "Deutscher Sportverein Hannover gegr. 1878 e.V.",
      "venue_address": "Ferdinand-Wilhelm-Fricke-Weg 2, 30169 Hannover"
    },
    "ui": {
      "color1": "#7d96bd",
      "color2": "#fcfdfd",
      "color3": "#022f7f",
    }
  },
  {
    "clubee_name": "RC Leipzig",
    "details": {
      "club_name": "Rugby Club Leipzig",
      "club_short": "RC Leipzig",
      "club_very_short": "RCL",
      "city": "Leipzig",
      "venue_name": "Sportplatzanlage Stahmeln",
      "venue_address": "Stahmelner Straße 218 04159 Leipzig"
    },
    "ui": {
      "color1": "#b0b0b0",
      "color2": "#6b6b6b",
      "color3": "#1d1d1d",
    }
  },
  {
    "clubee_name": "RK 03 Berlin",
    "details": {
      "club_name": "Rugby Klub 03 Berlin",
      "club_short": "RK03 Berlin",
      "club_very_short": "RK03",
      "city": "Berlin",
      "venue_name": "Sportplatz Buschallee",
      "venue_address": "Hansastr. 190, 13088 Berlin"
    },
    "ui": {
      "color1": "#d8a107",
      "color2": "#343427",
      "color3": "#f5f5f5",
    }
  },
  {
    "clubee_name": "Berliner RC",
    "details": {
      "club_name": "Berliner Rugby Club",
      "club_short": "Berliner RC",
      "club_very_short": "BRC",
      "city": "Berlin",
      "venue_name": "Sportplatz Jungfernheide",
      "venue_address": "Jungfernheideweg 70, 13629 Berlin"
    },
    "ui": {
      "color1": "#61282a",
      "color2": "#9c8d8e",
      "color3": "#faf9f9",
    }
  },
  {
    "clubee_name": "Hamburger Rugby-Club",
    "details": {
      "club_name": "Hamburger Rugby-Club",
      "club_short": "Hamburger RC",
      "club_very_short": "HRC",
      "city": "Hamburg",
      "venue_name": "Rugby-Arena Stadtpark",
      "venue_address": "Saarlandstraße 71, 22303 Hamburg"
    },
    "ui": {
      "color1": "#a0120a",
      "color2": "#fdf810",
      "color3": "#fefcf5",
    }
  },
  {
    "clubee_name": "FC St. Pauli",
    "details": {
      "club_name": "FC St. Pauli Rugby",
      "club_short": "FC St. Pauli",
      "club_very_short": "FC SP",
      "city": "Hamburg",
      "venue_name": "Rugby-Arena Stadtpark",
      "venue_address": "Saarlandstraße 71, 22303 Hamburg"
    },
    "ui": {
      "color1": "#c88d85",
      "color2": "#c12a20",
      "color3": "#faf7f6",
    }
  },
  {
    "clubee_name": "BSV 1892 Rugby",
    "details": {
      "club_name": "Berliner Sport Verein 1892 Rugby",
      "club_short": "Berliner SV 1892",
      "club_very_short": "BSV92",
      "city": "Berlin",
      "venue_name": "Sportplatz Forckenbeckstraße",
      "venue_address": "Forckenbeckstr. 14a, 14199"
    },
    "ui": {
      "color1": "#403434",
      "color2": "#a7a0a1",
      "color3": "#f9f8f8",
    }
  },
  {
    "clubee_name": "BSV",
    "details": {
      "club_name": "Berliner Sport Verein",
      "club_short": "Berliner SV",
      "club_very_short": "BSV",
      "city": "Berlin",
      "venue_name": "Sportplatz Forckenbeckstraße",
      "venue_address": "Forckenbeckstr. 14a, 14199"
    },
  },
  {
    "clubee_name": "SV Ricklingen",
    "details": {
      "club_name": "SV 1908 Ricklingen",
      "club_short": "SV Ricklingen",
      "club_very_short": "SVR",
      "city": "Hannover",
      "venue_name": "Sportplatz SV Ricklingen",
      "venue_address": "Ricklinger Stadtweg 1, 30459 Hannover"
    },
  },
  {
    "clubee_name": "Rugby Cricket Dresden",
    "details": {
      "club_name": "Rugby Cricket Dresden",
      "club_short": "RC Dresden",
      "club_very_short": "RCD",
      "city": "Dresden",
      "venue_name": "Sportplatz Heinz-Steyer-Stadion",
      "venue_address": "Magdeburger Str. 10, 01067 Dresden"
    },
  },
    {
        "clubee_name": "TSV Victoria Linden",
        "details": {
          "club_name": "TSV Victoria Linden",
          "club_short": "TSV V. Linden",
          "club_very_short": "TSV VL",
          "city": "Hannover",
          "venue_name": "Sportplatz TSV Victoria Linden",
          "venue_address": "Am Lindener Hafen 1, 30453 Hannover"
        },
    },
    {
        "clubee_name": "SG Rugbyunion Hohen Neuendorf e.V.",
        "details": {
          "club_name": "SG Rugbyunion Hohen Neuendorf",
          "club_short": "SGR H. Neuendorf",
          "club_very_short": "SG RUHN",
          "city": "Hohen Neuendorf",
          "venue_name": "Sportplatz Hohen Neuendorf",
          "venue_address": "Bergfelder Weg 1, 16540 Hohen Neuendorf"
        },
    },
    {
      "clubee_name": "Heidelberger Turnverein 1846",
      "details": {
        "club_name": "Heidelberger Turnverein 1846",
        "club_short": "Heidelberger TV",
        "club_very_short": "HTV",
        "city": "Heidelberg",
        "venue_name": "Sportplatz Heidelberger TV",
        "venue_address": "Im Neuenheimer Feld 6, 69120 Heidelberg"
      },
    },
  {
    "clubee_name": "Heidelberger Turnverein",
    "details": {
      "club_name": "Heidelberger Turnverein",
      "club_short": "Heidelberger TV",
      "club_very_short": "HTV",
      "city": "Heidelberg",
      "venue_name": "Sportplatz Heidelberger TV",
      "venue_address": "Im Neuenheimer Feld 6, 69120 Heidelberg"
    },
  },
  {
   "clubee_name": "RC Unterföhring",
      "details": {
        "club_name": "Rugby Club Unterföhring",
        "club_short": "RC Unterföhring",
        "club_very_short": "RCU",
        "city": "Unterföhring",
        "venue_name": "Sportplatz Unterföhring",
        "venue_address": "Mitterfeldallee 2, 85774 Unterföhring"
      },
  },
  {
    "clubee_name": "RK Heusenstamm",
    "details": {
      "club_name": "Rugby Klub Heusenstamm",
      "club_short": "RK Heusenstamm",
      "club_very_short": "RKH",
      "city": "Heusenstamm",
      "venue_name": "Sportplatz Heusenstamm",
      "venue_address": "Am Sportfeld 1, 63150 Heusenstamm"
    },
  },
  {
    "clubee_name": "Rugby-Club Rottweil",
    "details": {
      "club_name": "Rugby-Club Rottweil",
      "club_short": "RC Rottweil",
      "club_very_short": "RCR",
      "city": "Rottweil",
      "venue_name": "Sportplatz Rottweil",
      "venue_address": "Am Wasserturm 1, 78628 Rottweil"
    },
  },
  {
    "clubee_name": "Walferdange Rugby Seniors",
    "details": {
      "club_name": "Rugby Club Walferdange",
      "club_short": "RC Walferdange",
      "club_very_short": "RCW",
      "city": "Walferdange",
      "venue_name": "Sportplatz Walferdange",
      "venue_address": "Am Duerf 1, 7222 Walferdange"
    },
  },
  {
    // Aktueller Name bei Clubee (Umbenennung waehrend der Saison 2025/26).
    "clubee_name": "SG SV Studentenstadt Freimann / ESV München-Freimann",
    "details": {
      "club_name": "SG SV Studentenstadt Freimann / ESV München-Freimann",
      "club_short": "SG StuSta / ESV",
      "club_very_short": "StuSta",
      "city": "München",
      "venue_name": "Sportplatz StuSta",
      "venue_address": "Connollystraße 32, 80809 München"
    },
  },
  {
    // Alias auf den alten Clubee-Namen, greift solange gecachte Daten aus
    // 2025/26 ausgeliefert werden.
    "clubee_name": "StuSta Rugby",
    "details": {
      "club_name": "SG SV Studentenstadt Freimann / ESV München-Freimann",
      "club_short": "StuSta",
      "club_very_short": "StuSta",
      "city": "München",
      "venue_name": "Sportplatz StuSta",
      "venue_address": "Connollystraße 32, 80809 München"
    },
  },
  {
    "clubee_name": "Sport-Union Neckarsulm",
    "details": {
      "club_name": "Sport-Union Neckarsulm",
      "club_short": "SU Neckarsulm",
      "club_very_short": "SUN",
      "city": "Neckarsulm",
      "venue_name": "Sportplatz Neckarsulm",
      "venue_address": "Am Sportplatz 1, 74172 Neckarsulm"
    },
  },
  {
    // Neu in der 2. Bundesliga Nord/Ost ab Saison 2026/27.
    // Vereinsdaten aus Clubee (clubs/4406). Die dort hinterlegte Anschrift
    // Gustav-Brandt-Str. 82, 30173 Hannover ist die Vereinsadresse, nicht
    // bestaetigt als Spielstaette.
    // TODO: Spielstaette beim Verein erfragen.
    "clubee_name": "VfR 06",
    "details": {
      "club_name": "Verein für Rasenspiele Döhren - 1906 e.V.",
      "club_short": "VfR 06 Döhren",
      "club_very_short": "VfR 06",
      "city": "Hannover",
      "venue_name": "",
      "venue_address": ""
    },
  },
  {
    // Neu in der 2. Bundesliga Sued/West ab Saison 2026/27.
    // Vereinsdaten aus Clubee (clubs/4440); dort ist keine Anschrift hinterlegt.
    // TODO: Spielstaette beim Verein erfragen.
    "clubee_name": "Stuttgarter Rugby-Club",
    "details": {
      "club_name": "Stuttgarter Rugby Club e.V.",
      "club_short": "Stuttgarter RC",
      "club_very_short": "SRC",
      "city": "Stuttgart",
      "venue_name": "",
      "venue_address": ""
    },
  }
]
export default clubInfo;
